var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-popup',{attrs:{"save-button-text":"Yes","button-icon":"mdi-send","title":_vm.title,"popup-model":_vm.show,"width":_vm.maxWidth,"show-save-button":_vm.showSaveButton},on:{"onCancelButtonClick":_vm.onCancelButtonClick,"onSaveButtonClick":_vm.onConfirmButtonClick}},[_c('div',{staticClass:"confirm-popup mt-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }